import { render, staticRenderFns } from "./service-subscribers.vue?vue&type=template&id=10c0031b&"
import script from "./service-subscribers.vue?vue&type=script&lang=js&"
export * from "./service-subscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports